import { getV3Configuration } from '../api/configuration';
import User from '@/store/user';
import ConfigurationStore from '../store/configuration';

export function getOrFetchConfiguration() {
  if (ConfigurationStore.isFetched()) {
    return ConfigurationStore.getValue();
  }
  return updateConfiguration();
}

export async function updateConfiguration() {
  const config = await getV3Configuration();
  ConfigurationStore.update(config);
  return config;
}

export function createPaymentMethods(config) {
  const methods =
    config?.order?.payment?.methods?.map(item => {
      const { title, enabled, extraFeeDescription, ...rest } = item;
      return { ...rest, name: title || '', unavailable: !enabled, subTitle: extraFeeDescription };
    }) ?? [];

  return methods;
}

export function filterByAllowedTypes(list, allowedTypes) {
  return list.filter(item => allowedTypes.includes(item.type));
}

export function getPaymentMethods(saveText, selectedService) {
  if (!ConfigurationStore.isFetched()) return [];

  const payment = ConfigurationStore.getValue()?.order?.payment;
  if (!payment) return [];

  const methods = payment.methods?.map(item => {
    const { title, enabled, extraFeeDescription, ...rest } = item;
    return { ...rest, name: title || '', unavailable: !enabled, subTitle: extraFeeDescription };
  });

  if (!methods) return [];

  const cards = User.getUserCards() ?? [];
  const gateways = payment.creditCard?.gateways?.filter(g => g.enabled) ?? [];
  const canSaveCard = !!payment.creditCard?.save;

  const allMethods = methods.flatMap(method => {
    if (method.unavailable) {
      return [];
    }

    if (method.type !== 'card') {
      return [method];
    }

    return [
      {
        ...method,
        checkbox: canSaveCard,
        subTitle: canSaveCard ? saveText : method.subTitle,
        savedCards: cards.map(card => ({
          type: 'card',
          name: card.name ?? method.name,
          cardId: card._id,
          _id: card._id,
          maskedNumber: card.maskedNumber,
          cardScheme: card.cardScheme,
          unavailable: false,
        })),
        gateways: gateways.map(g => ({
          id: g.id,
          title: g.title,
          paymentGateway: g.paymentGateway,
        })),
      },
    ];
  });

  if (selectedService?.availablePaymentTypes?.length > 0) {
    return filterByAllowedTypes(allMethods, selectedService.availablePaymentTypes);
  }

  return allMethods;
}

export function getBankAccounts() {
  if (ConfigurationStore.isFetched()) {
    const accounts = ConfigurationStore.getValue()?.order?.payment?.methods?.find(item => item.type === 'bankTransfer');
    return accounts?.bankAccountsConfig?.accounts;
  } else {
    return [];
  }
}

export function getPaymentConfigurations() {
  if (ConfigurationStore.isFetched()) {
    return ConfigurationStore.getValue()?.order?.checkout?.paymentOptions;
  } else {
    return undefined;
  }
}

export function getBagsConfigurations() {
  if (ConfigurationStore.isFetched()) {
    return ConfigurationStore.getValue()?.order?.bagsCalculation?.bagsRequired;
  } else {
    return true;
  }
}

export default {
  getOrFetchConfiguration,
  updateConfiguration,
  getPaymentMethods,
  getPaymentConfigurations,
  getBankAccounts,
  getBagsConfigurations,
  filterByAllowedTypes,
};
